/**
 * Web Entry Point
 */
import { AppRegistry, Alert, Dimensions } from 'react-native';
import App from './App';
import { name as appName } from './app.json';
import AlertMock from './src/webMocks/Alert';

import { enableScreens } from 'react-native-screens';

// Disable native screen stack on web to prevent container height / display glitches
enableScreens(false);

// Filter out external browser extension errors and guard history on file://
if (typeof window !== 'undefined') {
  if (window.history) {
    const originalReplaceState = window.history.replaceState?.bind(window.history);
    const originalPushState = window.history.pushState?.bind(window.history);

    if (originalReplaceState) {
      window.history.replaceState = function (data, unused, url) {
        try {
          if (window.location.protocol === 'file:' && url && String(url).startsWith('/')) {
            return;
          }
          return originalReplaceState(data, unused, url);
        } catch (e) {
          // Suppress SecurityError on file:// protocol
        }
      };
    }

    if (originalPushState) {
      window.history.pushState = function (data, unused, url) {
        try {
          if (window.location.protocol === 'file:' && url && String(url).startsWith('/')) {
            return;
          }
          return originalPushState(data, unused, url);
        } catch (e) {
          // Suppress SecurityError on file:// protocol
        }
      };
    }
  }

  window.addEventListener('error', (event) => {
    if (
      event.filename?.includes('chrome-extension:') ||
      event.filename?.includes('moz-extension:') ||
      event.message?.includes('M_ID')
    ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  window.addEventListener('unhandledrejection', (event) => {
    const reasonStr = String(event.reason?.stack || event.reason?.message || event.reason || '');
    if (reasonStr.includes('chrome-extension:') || reasonStr.includes('M_ID')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
}

// Patch Alert on web
if (Alert) {
  Alert.alert = AlertMock.alert;
}

// Patch Dimensions on web so that board and screens calculate dimensions based on max-width 480px container
if (Dimensions && Dimensions.get) {
  const originalGet = Dimensions.get.bind(Dimensions);
  Dimensions.get = (dim) => {
    const result = originalGet(dim);
    if (dim === 'window' || dim === 'screen') {
      const maxWidth = 480;
      const effectiveWidth = Math.min(result.width, maxWidth);
      return {
        ...result,
        width: effectiveWidth,
      };
    }
    return result;
  };
}

// Register the app
AppRegistry.registerComponent(appName, () => App);

// Run the application on web
const rootTag = document.getElementById('root');
if (rootTag) {
  AppRegistry.runApplication(appName, {
    initialProps: {},
    rootTag,
  });
}
